import { createContext, useReducer } from "react";

export const PhilosophyContext = createContext();

export const philosophyReducer = (state, action) => {
    switch (action.type) {
        case 'SET_PHILOSOPHY':
            return {
                philosophy: action.payload
            }
        case 'CREATE_PHILOSOPHY':
            return {
                philosophy: [action.payload, ...state.philosophy]
            }
        case 'DELETE_PHILOSOPHY':
            return {
                philosophy: state.philosophy.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const PhilosophyContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(philosophyReducer, {
        philosophy: null
    });

    return (
        <PhilosophyContext.Provider value={{ ...state, dispatch }}>
            {children}
        </PhilosophyContext.Provider>
    );
};